module.exports = __webpack_public_path__ + "static/media/20210403_200020_502_IMG_0004.0a3e3c54.jpg";